import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import LineView from "../components/LineView";
import mealTypes from "../../../constants/meal-types";
import Divider from "../components/Divider";
import RecordView from "../components/RecordView";
import MealDetailView from "../components/MealDetailView";
class MealLogStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.d;
  };
  addContentViewModel = (parts, handler) => {
    let meta = this.story.story;
    let mts = [
      [mealTypes.BREAKFAST, t("Breakfast")],
      [mealTypes.LUNCH, t("Lunch")],
      [mealTypes.DINNER, t("Dinner")],
      [mealTypes.SNACKS, t("Snacks")],
    ];
    parts.push({
      type: MealDetailView,
      props: {
        mts: mts,
        meta: meta,
        isModal: this.isModal,
      },
      key: `ml-ti-${this.story.story_id}`,
    });
    parts[parts.length - 1].props.paddingBottom = 10;
  };
}
export default MealLogStoryViewModel;
